import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import "./Auth.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import axios from 'axios'
import { IoMdCloseCircleOutline } from "react-icons/io";
import QRCode from 'react-qr-code';

export default function Auth({ isMobile, closePopup, typeDefault }) {

  const [type, setType] = useState(typeDefault);
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [errorUserName, setErrorUserName] = useState(null);
  const [errorPassword, setErrorPassword] = useState(null);
  const [errorConfirmPassword, setErrorConfirmPassword] = useState(null);
  const [errorEmail, setErrorEmail] = useState(null);
  const [CodeConfirm, setCodeConfirm] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [secretKey, setSecretKey] = useState("");

  // useEffect(() => {
  //   generateSecretKey();
  // }, []);

  const createSecret = (secretLength = 16) => {
    const validChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
    let secret = '';

    for (let i = 0; i < secretLength; i++) {
      secret += validChars.charAt(Math.floor(Math.random() * validChars.length));
    }

    return secret;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const onChangeConfirmPassword = (value) => {
    setFormData(prevState => ({
      ...prevState,
      confirmPassword: value
    }));
  };

  const validarCampos = () => {
    const errores = {};

    if (!formData.email || !/^\S+@\S+\.\S+$/.test(formData.email)) {
      errores.email = 'El email es inválido';
    }

    if (!formData.username || !/^[a-zA-Z0-9]{4,10}$/.test(formData.username)) {
      errores.username = 'La cuenta debe tener entre 4 y 10 caracteres alfanuméricos';
    }

    if (!formData.password || !/^[a-zA-Z0-9~!#$%&*-_+=|:.]{6,10}$/.test(formData.password)) {
      errores.password = 'La contraseña debe tener entre 6 y 10 caracteres y solo puede contener números, letras y los siguientes caracteres: ~ ! # $ % & * - _ + = | : .';
    }

    if (formData.password !== formData.confirmPassword) {
      errores.confirmPassword = 'Las contraseñas no coinciden';
    }

    return errores;
  };

  const handleNextStep = async () => {
    // Validar los campos
    const errores = validarCampos();

    // Si hay errores, mostramos los mensajes de error
    if (Object.keys(errores).length > 0) {
      setErrorUserName(errores.username || '');
      setErrorEmail(errores.email || '');
      setErrorPassword(errores.password || '');
      setErrorConfirmPassword(errores.confirmPassword || '');
      return; // Detener el proceso si hay errores
    }

    try {
      // Verificar si la cuenta ya existe en el backend
      const response = await fetch('/gate/verificar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          account: formData.username // Utiliza el nombre de usuario como cuenta para verificar
        })
      });

      const data = await response.json();

      // Si la cuenta existe, establecer el mensaje de error en errorUserName
      if (data.exists) {
        setErrorUserName('La cuenta ya existe');
        return;
      }

      try {
        // Generar la clave secreta
        console.log("Generando secretKey...");
        const secretKey = createSecret();
        console.log("SecretKey generada:", secretKey);

        // Almacenar la clave secreta en el estado
        setSecretKey(secretKey);

        // Construir la URL del código QR utilizando la clave secreta generada
        const qrCodeData = `otpauth://totp/MuSerendipia:${formData.username}?secret=${secretKey}&issuer=MuSerendipia`;
        console.log("Construyendo qrCodeUrl:", qrCodeData);

        setQrCodeUrl(qrCodeData); // Asignar directamente la URL del código QR al estado
        setStep(1); // Avanzar al siguiente paso después de asignar la URL del código QR

      } catch (error) {
        console.error('Error al generar la clave secreta:', error);
        // Puedes manejar el error aquí, por ejemplo, mostrando un mensaje al usuario
      }

    } catch (error) {
      console.error('Error al verificar la cuenta:', error);
      // Puedes manejar el error aquí, por ejemplo, mostrando un mensaje al usuario
    }
  };

  const handleSignUp = async () => {
    try {
      const response = await axios.post('https://backmu.vercel.app/signup', formData);
      window.localStorage.setItem("token", String(response.data?.token));
      window.localStorage.setItem("_id", response._id);
      window.location.href = "/";
    } catch (error) {
      console.error('Error al crear usuario:', error.response.data.message);
    }
  };

  const handleLogin = async () => {
    try {
      const response = await axios.post('https://backmu.vercel.app/login', formData);
      console.log(response.data); // Muestra el token de acceso
      window.localStorage.setItem("token", String(response.data?.token));
      window.localStorage.setItem("_id", response._id);
      window.location.href = "/";

      // Aquí podrías almacenar el token en el estado o en el almacenamiento local del navegador
    } catch (error) {
      console.error('Error al iniciar sesión:', error.response.data.message);
      // Aquí podrías mostrar un mensaje de error al usuario en la interfaz
    }
  };
  const [verificationStatus, setVerificationStatus] = useState(""); // Estado de verificación del código

  // Función para manejar la verificación del código
  const handleVerifyCode = async (code) => {
    // Verificar si el código tiene exactamente 6 dígitos
    const isNumericSixDigits = /^\d{6}$/.test(code);

    if (!isNumericSixDigits) {
      //console.log("El código debe tener exactamente 6 dígitos numéricos.");
      return; // No enviar la solicitud al servidor si el código no cumple con los requisitos
    }

    try {
      // Realizar una solicitud al servidor para verificar el código
      const response = await axios.post('/gate/verificarqr', {
        secretKey: secretKey, // Enviar la clave secreta al servidor
        code: code // Enviar el código ingresado por el usuario al servidor
      });

      // Verificar si la respuesta del servidor indica que el código es correcto
      if (response.data.isValid) {
        setVerificationStatus("Correcto");
      } else {
        setVerificationStatus("Incorrecto");
      }
    } catch (error) {
      console.error('Error al verificar el código:', error);
      setVerificationStatus("Error en la verificación");
    }
  };

  const handleRegister = async () => {
    try {
      let requestData = {};

      requestData = {
        email: formData.email,
        account: formData.username,
        password: formData.password,
        authenticator: secretKey
      };

      // Realizar la solicitud al servidor
      const response = await axios.post('/gate/registronuevo', requestData);

      // Verificar si el registro fue exitoso
      if (response.data === true) {
        // Avanzar al siguiente paso
        setStep(2);
      } else {
        // Mostrar un mensaje de error si el registro falló
        console.error("Error en el registro");
        setStep(3);
      }
    } catch (error) {
      console.error('Error al registrar usuario:', error.response.data.message);
      setStep(3);
    }
  };

  async function handleSubmit() {
    if (type === 0) {
      try {

      } catch (err) {
        alert({ type: "ERROR", message: err });
      }
    }


    // if (type === 1) {

    //   if (rMonth === "null" && rMonth === null)
    //     return alert({ type: "ERROR", message: "Completa el mes" });
    //   if (rDay === "null" && rDay === null)
    //     return alert({ type: "ERROR", message: "Completa el dia" });
    //   if (rYear === "null" && rYear === null)
    //     return alert({ type: "ERROR", message: "Completa el año" });

    //   try {
    //     // const birthDate = `${rYear}-${rMonth}-${String(rDay).padStart(2, "0")}`;
    //     console.log('hola')

    //   } catch (err) {
    //     alert({ type: "ERROR", message: err.response.data.msg });
    //   }
    // }


    if (type === 2) {
      // if (isEmpty(recuperyMail))
      //   return alert({ type: "ERROR", message: "Please fill in all fields." });
      // if (!isEmail(recuperyMail))
      //   return alert({ type: "ERROR", message: "Invalid emails." });

      try {

      } catch (err) {
        alert({ type: "ERROR", message: err.response.data.msg });
      }
    }
  }

  const onKeyPressInput = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      handleSubmit();
    }
  };


  const [CodeConfirmInput, setCodeConfirmInput] = useState(0);

  function onChangeCodeConfirm(e) {
    setCodeConfirmInput(e);
  }



  function getType() {
    if (type === 0) {
      return (
        <div className="auth-content">
          <div className="auth-content-input">
            <p style={{ fontSize: '12px', fontFamily: 'inter' }}>Username*</p>
            <input
              name="email"
              id="identifierId"
              value={formData.email}
              onChange={handleChange}
              type="text"
            />
          </div>

          <div className="auth-content-input">
            <p style={{ fontSize: '12px', fontFamily: 'inter' }}>Contraseña</p>
            <input
              name="password"
              value={formData.password}
              onChange={handleChange}

              type="password"
            />
          </div>

          <a onClick={() => setType(2)} style={{ padding: 0 }}>
            <p
              className=""
              style={{
                fontSize: "12px",
                textAlign: "end",
                color: "#ff64b0",
                cursor: "pointer",
              }}
            >
              ¿Tienes problemas para iniciar sesión?
            </p>
          </a>

          {/*<div style={{marginTop: "5px", marginBottom: "10px"}}>
                        <ReCAPTCHA
                            size="normal"
                            sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
                            onChange={onChange}
                        />
            </div>*/}

          <button onClick={handleLogin} className="auth-button-login">
            Iniciar Sesión
          </button>

        </div>
      );
    }

    if (type === 1 && step === 0) {
      return (
        <div>
          {!CodeConfirm ? (
            <div className="auth-content">
              <div className="auth-content-input">
                <p style={{ fontSize: '12px', fontFamily: 'inter' }}>Email*</p>
                <input
                  className={errorEmail && "input-error"}
                  value={formData.email}
                  onChange={handleChange}
                  name="email"
                  type="text"
                />
                {errorEmail && <p style={{ fontSize: "10px", color: "rgb(228, 122, 122)", marginTop: "5px" }}>{errorEmail}</p>}
              </div>
              <div className="auth-content-input">
                <p style={{ fontSize: '12px', fontFamily: 'inter' }}>Cuenta*</p>
                <input
                  className={errorUserName && "input-error"}
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  type="text"
                />
                {errorUserName && <p style={{ fontSize: "12px", color: "rgb(228, 122, 122)", marginTop: "5px", fontFamily: 'inter' }}>{errorUserName}</p>}
              </div>
              <div className="auth-content-input">
                <p style={{ fontSize: '12px', fontFamily: 'inter' }}>Contraseña*</p>
                <input
                  className={errorPassword && "input-error"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  type="password"
                />
                {errorPassword && <p style={{ fontSize: "10px", color: "rgb(228, 122, 122)", marginTop: "5px" }}>{errorPassword}</p>}
              </div>
              <div className="auth-content-input">
                <p style={{ fontSize: '12px', fontFamily: 'inter' }}>Repite la contraseña*</p>
                <input
                  className={errorConfirmPassword && "input-error"}
                  onChange={(e) => onChangeConfirmPassword(e.target.value)}
                  type="password"
                />
                {errorConfirmPassword && <p style={{ fontSize: "10px", color: "rgb(228, 122, 122)", marginTop: "5px" }}>{errorConfirmPassword}</p>}
              </div>
              <div className="auth-text">
                <input type="checkbox" style={{ width: '5%', border: 0 }} />
                <p className="" style={{ fontSize: "11px" }}>
                  He leído las {" "}<a style={{ color: "#ff64b0", cursor: "pointer" }}>Reglas</a>{" "}
                  y estoy de acuerdo con ellas.
                </p>
              </div>
              <button onClick={handleNextStep} className="auth-button-login">
                Siguiente paso
              </button>
            </div>
          ) : (
            <div className="auth-content">
              <div className="auth-content-input">
                <p>Revisa tu correo</p>
                <input onChange={(e) => onChangeCodeConfirm(e.target.value)} type="number" />
                <button style={{ width: "100%" }} className="auth-button-login">Enviar código</button>
              </div>
            </div>
          )}
        </div>
      );
    }

    if (type === 1 && step === 1) {
      console.log("Valor de qrCodeUrl:", qrCodeUrl); // Mostrar el valor en la consola

      return (
        <div className="auth-content">
          <h4>Escanea el código QR</h4>
          <div className="auth-content-input" style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginRight: '10px' }}>
              <QRCode value={qrCodeUrl} size={200} />
            </div>
            <div style={{ width: '200px', paddingLeft: '20px' }}>
              <p style={{ fontSize: '12px', fontFamily: 'Inter' }}>
                Para verificar tu cuenta, necesitarás descargar <a href="https://support.google.com/accounts/answer/1066447?hl=es" target="_blank">Google Authenticator</a> desde la tienda de aplicaciones de tu dispositivo. Luego, escanea el código que aparece en la pantalla e ingresa el código proporcionado.
              </p>
            </div>
          </div>
          <h4>Ingresa el código de verificación</h4>
          <div className="auth-content-input">
            <input
              style={{ width: '100%' }}
              type="text"
              pattern="\d{6}"
              maxLength={6}
              onChange={(e) => handleVerifyCode(e.target.value)}
            />
            <p>{verificationStatus}</p> {/* Mostrar estado de verificación */}
          </div>
          <button disabled={verificationStatus !== "Correcto"} onClick={handleRegister} className="auth-button-login">
            Crea tu cuenta
          </button>
        </div>
      );
    }

    if (type === 1 && step === 2) {
      return (
        <div className="auth-content">
          <div style={{ textAlign: "left", marginTop: "30px" }} className="auth-text">
            <h3>¡Bienvenido a Mu Serendipia!</h3>
          </div>

          <div className="auth-changelook-container">
            <img
              style={{ width: "150px" }}
              src="https://res.cloudinary.com/pinkker/image/upload/v1679518811/pinkker-ups_iqucmd.png"
              alt="Pinkker"
            />
          </div>

          <button style={{ marginTop: "50px" }} className="auth-button-login" onClick={() => closePopup()}>
            Cerrar
          </button>
        </div>
      );
    }

    if (type === 1 && step === 3) {
      return (
        <div className="auth-content">
          <h3>¡Lo sentimos!</h3>
          <div style={{ textAlign: "left", marginTop: "30px" }} className="auth-text">
            <p>Algo ha salido mal y no hemos podido crear la cuenta. Por favor, inténtalo nuevamente más tarde.</p>
          </div>

          <button style={{ marginTop: "50px" }} className="auth-button-login" onClick={() => closePopup()}>
            Cerrar
          </button>
        </div>
      );
    }

    if (type === 2 && step === 0) {
      return (
        <div className="auth-content">
          <div className="auth-content-input">
            <p>Email</p>
            <input
              id="identifierId"
              // onChange={(e) => setRecuperyMail(e.target.value)}
              type="text"
            />
          </div>

          <button onClick={() => handleSubmit()} className="auth-button-login">
            Enviar Correo
          </button>
        </div>
      );
    }

    if (type === 2 && step === 2) {
      return (
        <div className="auth-content">
          <div
            style={{ textAlign: "left", marginTop: "30px" }}
            className="auth-text"
          >
            <h3>¡Felicitaciones!</h3>
            <p>Estas a un paso de tener tu cuenta.</p>
          </div>

          <div className="auth-changelook-container">
            <img
              style={{ width: "150px" }}
              src="https://res.cloudinary.com/pinkker/image/upload/v1679518811/pinkker-ups_iqucmd.png"
            />
          </div>

          <div
            style={{ textAlign: "center", marginTop: "30px" }}
            className="auth-text"
          >
            <h3>¡Verifica tu mail!</h3>
            <p>
              Te enviamos un mail a tu correo electronico para verificar tu
              cuenta
            </p>
          </div>
          <button
            onClick={() => closePopup()}
            style={{ marginTop: "50px" }}
            className="auth-button-login"
          >
            Cerrar
          </button>
        </div>
      );
    }
  }

  return (
    <div className="auth-body-container">
      <div className={"auth-body"}>
        <div className={"auth-info"}>
          <div style={{ width: "100%" }}>
            <div
              style={{
                color: "#ededed",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: type === 0 ? "300px" : "500px",
              }}
            >
              {/* <div>
                <h5>Tu billete a Memelandia</h5>
                <p
                  style={{
                    fontSize: "12px",
                    color: "darkgray",
                    marginTop: "20px",
                  }}
                >
                  Ya sabes lo que dicen... <br /> Los amigos que hacen memes
                  juntos, transmiten juntos.
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    color: "darkgray",
                    marginTop: "20px",
                  }}
                >
                  👈👈👈 <br /> ¡Cree una cuenta para unirte a la conversación!
                </p>
              </div> */}
            </div>
          </div>

        </div>

        <div
          onKeyPress={(event) => onKeyPressInput(event)}
          className={"auth-container"}
          style={{ width: isMobile && '100% !important' }}
        >
          <div style={{ width: "100%" }}>
            {/* {type === 0 ? (
              <h3
                style={{
                  color: "#ededed",
                  marginBottom: "30px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {" "}
                <img
                  style={{ width: "50px" }}
                  src="/images/pinkker.png"
                  alt=""
                />{" "}
                Iniciar sesión en Pinkker
              </h3>
            ) : (
              <h3
                style={{
                  color: "#ededed",
                  marginBottom: "30px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  style={{ width: "50px" }}
                  src="/images/pinkker.png"
                  alt=""
                />{" "}
                Registrarse en Pinkker
              </h3>
            )} */}

            <div className="auth-title">

              <div
                onClick={() => setType(1)}
                className={
                  type === 1 ? "auth-title-card active" : "auth-title-card"
                }
              >
                <h6 style={{ color: "#ededed", fontFamily: 'Inter', fontWeight: 'bold' }}>Registrarse</h6>
              </div>

              <div
                onClick={() => setType(0)}
                className={
                  type === 0 ? "auth-title-card active" : "auth-title-card"
                }
              >
                <h6 style={{ color: "#ededed", fontFamily: 'Inter', fontWeight: 'bold' }}>Login</h6>
              </div>
            </div>

            {getType()}
          </div>
          <div className="auth-close">
            <button className="pinkker-button-more" onClick={closePopup}>

              <IoMdCloseCircleOutline style={{ fontSize: isMobile && "22px", color: 'white' }} />


            </button>
          </div>
        </div>


      </div>
    </div>
  );
}
